// 

import React, {Component} from "react";
import {connect} from "react-redux";
import {Col, Container,Row, Button, Collapse, Form} from "react-bootstrap";
import {Column, Table, AutoSizer, InfiniteLoader} from "react-virtualized";
import Draggable from "react-draggable";
import * as AWS from 'aws-sdk';
import * as _ from 'lodash';
import "./Logs.css";
import "react-virtualized/styles.css";
import {FILTER} from "../constants/Constants";
const strings = require('../resources/strings.json');

class Logs extends Component {
   
    state = {
        widths: {
            AccountId: 0.05,
            DateTime: 0.15,
            LogEvent: 0.2,
            Desc: 0.39,
            UserId: 0.07,
            DeviceId: 0.07,
            PremiseId: 0.07
          },
        items: [],
        lastEvaluatedKey: -1,
        open: false,
        filter: {},
        severityLevel: [
            "NONE",
            "INFO",
            "DEBUG",
            "WARN",
            "ERROR"
        ]
    }

    async componentDidMount(){
        await this.loadAllLogs();     
    }

    /** 
     * Get logs from AuditLog table
     */
    async loadAllLogs () {
        this.setAWSConfigWithCreds();
        await this.queryUpdateLogs();
    }

    async loadMore () {
        await this.queryUpdateLogs(true);
    }

    handleFetchClick(event){
        this.setState({
            items: [],
            lastEvaluatedKey: -1
        }, async function(){
            await this.queryUpdateLogs();
            this.tableRef.forceUpdateGrid();
        });
    };

    setAWSConfigWithCreds() {
        // Initialize the Amazon Cognito credentials provider
        AWS.config.region = process.env.REACT_APP_AWS_REGION; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: process.env.REACT_APP_AWS_COGNITO_POOL_UD,
        });
    }

    /**
     * Query for logs.
     * In absence of any filter, show warning messages
     * @param continueLoading, if true use lastEvaluatedKey to show the next set of logs 
     */
    async queryUpdateLogs(continueLoading){
        //No filter present. Show high priority logs
        if(continueLoading && !this.state.lastEvaluatedKey){
            return;
        }
        
        const params = this.generateQuery();

        if(this.state.lastEvaluatedKey && this.state.lastEvaluatedKey !== -1){
            params.ExclusiveStartKey = this.state.lastEvaluatedKey
        }

        try{
            const docClient = new AWS.DynamoDB.DocumentClient();
            let logData = await docClient.query(params).promise();
            if(logData.LastEvaluatedKey){
                console.log("LastEvaluatedKey: " + JSON.stringify(logData.LastEvaluatedKey));
            }
            this.setState({
                items: this.state.items.concat(logData.Items),
                lastEvaluatedKey: logData.LastEvaluatedKey? logData.LastEvaluatedKey: null
            });
        }catch(err){
            console.log("Error querying logs" );
            throw err;
        }
    }


    generateQuery(){
        if(this.state.accountId && (this.state.filter.severity == undefined || this.state.filter.severity === "NONE") ){
            return this.generateAccountBasedQuery();
        }else{
            return this.generateSeverityBasedQuery();
        }
    }

    generateAccountBasedQuery(){
        const params = {
            TableName : "AuditLog",
            KeyConditionExpression: "#accountId = :valAcctId and #timestamp > :valTimestamp",
            ExpressionAttributeValues: {
                 ":valAcctId" : parseInt(this.state.accountId),
                 ":valTimestamp" : 0
            },
            ExpressionAttributeNames: {
                "#accountId" : "AccountId",
                "#timestamp" : "Timestamp"
            },
            ScanIndexForward: false
        };

        if(!_.isEmpty(this.state.filter)){
            if(this.state.filter.userId){
                this.addFilterToQueryParams(params, FILTER.USERID);
            }
            if(this.state.filter.premiseId){
                this.addFilterToQueryParams(params, FILTER.PREMISEID);
            }
            if(this.state.filter.deviceId){
                this.addFilterToQueryParams(params, FILTER.DEVICEID);
            }
            if(this.state.filter.logEvent){
                this.addFilterToQueryParams(params, FILTER.EVENT);
            }
            if(this.state.filter.severity && this.state.filter.severity !== "NONE"){
                this.addFilterToQueryParams(params, FILTER.SEVERITY);
            }
        }else{
            params.Limit = 15;
        }

        return params;
    }

    generateSeverityBasedQuery(){
        const params = {
            TableName : "AuditLog",
            IndexName: "Severity-index",
            KeyConditionExpression: "#severity = :valSeverity and #timestamp > :valTimestamp",
            ExpressionAttributeValues: {
                 ":valSeverity" : (this.state.filter.severity === undefined) ? "WARN" : this.state.filter.severity,
                 ":valTimestamp" : 0
            },
            ExpressionAttributeNames: {
                "#severity" : "Severity",
                "#timestamp" : "Timestamp"
            },
            ScanIndexForward: false
        };

        if(!_.isEmpty(this.state.filter)){
            if(this.state.filter.userId){
                this.addFilterToQueryParams(params, FILTER.USERID);
            }
            if(this.state.filter.premiseId){
                this.addFilterToQueryParams(params, FILTER.PREMISEID);
            }
            if(this.state.filter.deviceId){
                this.addFilterToQueryParams(params, FILTER.DEVICEID);
            }
            if(this.state.filter.logEvent){
                this.addFilterToQueryParams(params, FILTER.EVENT);
            }
            if(this.state.accountId){
                this.addFilterToQueryParams(params, FILTER.ACCOUNTID);
            }
        }else{
            params.Limit = 15;
        }

        return params;
    }

    addFilterToQueryParams(params, filter){
        switch(filter){
            case FILTER.USERID:{
                params.ExpressionAttributeNames["#userId"] = strings.userId;
                params.ExpressionAttributeValues[":valUserId"] = parseInt(this.state.filter.userId);
                params.FilterExpression = !params.FilterExpression ? "#userId = :valUserId" : 
                params.FilterExpression + " AND " + "#userId = :valUserId";
                break;
            }
            case FILTER.PREMISEID:{
                params.ExpressionAttributeNames["#premiseId"] = strings.premiseId;
                params.ExpressionAttributeValues[":valPremiseId"] = parseInt(this.state.filter.premiseId);
                params.FilterExpression = "#premiseId = :valPremiseId"
                break;
            }
            //case Constants.FILTER.DEVICEID:{
            case FILTER.DEVICEID: {    
                params.ExpressionAttributeNames["#deviceId"] = strings.deviceId;
                params.ExpressionAttributeValues[":valDeviceId"] = parseInt(this.state.filter.deviceId);
                params.FilterExpression = "#deviceId = :valDeviceId"
                break;
            }
            case FILTER.EVENT:{
                params.ExpressionAttributeNames["#logEvent"] = strings.logEvent;
                params.ExpressionAttributeValues[":valLogEvent"] = this.state.filter.logEvent.trim();
                params.FilterExpression = !params.FilterExpression ? "#logEvent = :valLogEvent" : 
                params.FilterExpression + " AND " + "#logEvent = :valLogEvent";
                break;
            }
            case FILTER.SEVERITY:{
                params.ExpressionAttributeNames["#severity"] = strings.severity;
                params.ExpressionAttributeValues[":valSeverity"] = this.state.filter.severity.trim();
                params.FilterExpression =  !params.FilterExpression ? "#severity = :valSeverity" : 
                params.FilterExpression + " AND " + "#severity = :valSeverity";
                break;
            }
            case FILTER.ACCOUNTID: {
                params.ExpressionAttributeNames["#accountId"] = strings.accountId;
                params.ExpressionAttributeValues[":valAccountId"] = parseInt(this.state.accountId);
                params.FilterExpression =  !params.FilterExpression ? "#accountId = :valAccountId" : 
                params.FilterExpression + " AND " + "#accountId = :valAccountId";
                break;
            }
            default: {
				
	        }	
        }
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <div>
                            <Button className="btn" onClick={() => this.setState({open:!this.state.open})}>
                                Filter
                            </Button>

                            <Collapse in={this.state.open}>
                                <Form>
                                    <Form.Group>
                                        <Row>
                                        <Col sm={1} >
                                            Account
                                            <Form.Control type="account" value={this.state.accountId || ''}
                                                onChange={(event) => { this.setState(
                                                                {accountId:event.target.value}) }}/>
                                        </Col>
                                        <Col sm={1}>
                                            User Id
                                            <Form.Control type="userId" value={this.state.filter.userId || ''}
                                                onChange={(event) => { this.setState(
                                                    {filter: {...this.state.filter, userId:event.target.value}}) }}/>
                                        </Col>
                                        <Col sm={1} >
                                            Premise
                                            <Form.Control type="premiseId" value={this.state.filter.premiseId || ''}
                                                onChange={(event) => { this.setState(
                                                    {filter: {...this.state.filter, premiseId:event.target.value}}) }}/>
                                        </Col>
                                        <Col sm={1} >
                                            Device Id
                                            <Form.Control type="deviceId" value={this.state.filter.deviceId || ''}
                                                onChange={(event) => { this.setState(   
                                                    {filter: {...this.state.filter, deviceId:event.target.value}}) }}/>
                                        </Col>
                                        <Col sm={3} >
                                            Event
                                            <Form.Control type="event" value={this.state.filter.logEvent || ''}
                                                onChange={(event) => { this.setState(   
                                                    {filter: {...this.state.filter, logEvent:event.target.value}}) }}/>
                                        </Col>
                                        <Col sm={2} >
                                            Severity
                                            <select className="form-control" value={this.state.filter.severity || ''}
                                               onChange={(event) => { this.setState(   
                                                {filter: {...this.state.filter, severity:event.target.value}}) }}>
                                            {
                                                this.state.severityLevel.map((e, key) => {
                                                    return <option key={key} value={e}>{e}</option>;
                                                })
                                            }
                                        </select>
                                        </Col>
                                        <Col sm={3}>
                                            <Button variant="primary" onClick={() => this.handleFetchClick()}
                                                    style={{marginRight: 16}}>Fetch</Button>
                                            <Button variant="primary" 
                                                    onClick={() => this.setState({accountId:'', filter:{}})}
                                                    style={{marginRight: 16}}>Clear</Button>
                                        </Col>
                                        </Row>
                                    </Form.Group>
                                </Form>
                            </Collapse>
                        </div>
                    </Col>    
                </Row>
                <Row><input style={{border:"0px"}} type="text" name="name" value={"Fetched " + this.state.items.length + " entries"}/></Row>
                <Row>
                    <Col>
                    <InfiniteLoader
                            isRowLoaded={({ index}) => !!this.state.items[index]}
                            loadMoreRows={() => this.loadMore()}
                            rowCount={1000000} //Some random big number
                            >
                            {({onRowsRendered, registerChild}) => (
                                <AutoSizer>
                                    {({width, height}) => (
                                        <Table
                                            filter={this.state.filterUserId}
                                            ref={(ref) => { this.tableRef = ref; ref = registerChild}}
                                            onRowsRendered={onRowsRendered}
                                            rowClassName='table-row'
                                            headerHeight={40}
                                            width={width}
                                            height={400}
                                            rowHeight={40}
                                            rowCount={this.state.items.length}
                                            rowGetter={({ index }) => this.state.items[index]}
                                            onHeaderClick={this.onHeaderClick}
                                            >
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='Acct'
                                                    dataKey='AccountId'
                                                    width={this.state.widths.AccountId*width}
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='DateTime'
                                                    dataKey='DateTime'
                                                    width={this.state.widths.DateTime*width}
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='Event'
                                                    dataKey='LogEvent'
                                                    width={this.state.widths.LogEvent*width}   
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='Desc'
                                                    dataKey='Desc'
                                                    width={this.state.widths.Desc*width}
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='UserId'
                                                    dataKey='UserId'
                                                    width={this.state.widths.UserId*width}
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='PremiseId'
                                                    dataKey='PremiseId'
                                                    width={this.state.widths.PremiseId*width}
                                                />
                                                <Column
                                                headerRenderer={this.headerRenderer}
                                                    label='DeviceId'
                                                    dataKey='DeviceId'
                                                    width={this.state.widths.DeviceId*width}
                                                />    
                                        </Table>
                                    )}
                                </AutoSizer>
                            )}
                        </InfiniteLoader>
                    </Col>
                </Row>
            </Container>
        );
    }

    headerRenderer = ({
        columnData,
        dataKey,
        disableSort,
        label,
        sortBy,
        sortDirection
      }) => {
        return (
          <React.Fragment key={dataKey}>
            <div className="ReactVirtualized__Table__headerTruncatedText">
              {label}
            </div>
            <Draggable
              axis="x"
              defaultClassName="DragHandle"
              defaultClassNameDragging="DragHandleActive"
              onDrag={(event, { deltaX }) =>
                this.resizeRow({
                  dataKey,
                  deltaX
                })
              }
              position={{ x: 0 }}
              zIndex={999}
            >
              <span className="DragHandleIcon">⋮</span>
            </Draggable>
          </React.Fragment>
        );
      };
    
      resizeRow = ({ dataKey, deltaX }) =>
        this.setState(prevState => {
          const prevWidths = prevState.widths;
          const percentDelta = deltaX / 1000;
    
          // This is me being lazy :)
          const nextDataKey = this.getNextDataKey(dataKey);
          return {
            widths: {
                ...prevWidths,
                [dataKey]: prevWidths[dataKey] + percentDelta,
                [nextDataKey]: prevWidths[nextDataKey] - percentDelta
              } 
          };
        });

    getNextDataKey = (dataKey) => {
        switch(dataKey){
            case 'AccountId': 
                return 'DateTime';
            case 'DateTime':
                return 'LogEvent';
            case 'LogEvent':
                return 'Desc';
            case 'Desc':
                return 'UserId';
            case 'UserId':
                return 'DeviceId';
            case 'DeviceId':
                return 'PremiseId';
            default:
                return 'DateTime';
        }
    }
}

const mapStateToProps = (state, props) => {
    return {
        premise: state.userInfoReducer.premiseData,
    };
};

const R_Logs = connect(mapStateToProps)(Logs);
export default R_Logs;
